import { useEffect, useRef, useState } from "react";
import WriteTabbarItemMobile from "components/community/write/write_tabbar_item_m";
import WriteAddImageSlider from "components/community/write/write_add_image_slider";
import { createCommunityPost } from "firebase_/firebase_function/firebase_community";
import { useUser } from "util/context/user_context";
import ConfirmDialog from "components/confirm_dialog";
import OnlyConfirmDialog from "components/onlyConfirm_dialog";
import { useNavigate } from "react-router-dom";
import Styles from "css/community_css/mobile/community_write_m.module.css";
import BackArrow from "assets/community_assets/write/header/back_arrow_icon.svg";
import OnlyLoadingScreen from "components/loading_screen";

export default function CommunityWriteScreen({ isMobile }) {
  const { userData } = useUser();
  const navigate = useNavigate();

  /// ✅ 탭 바 관련
  const tabBarItem = ["이야기", "고장문의"];
  const [selectTabBar, setSelectTabBar] = useState("이야기");

  /// ✅ 글쓰기 요소
  const [images, setImages] = useState([]); // 추가한 이미지
  const [title, setTitle] = useState(""); // 제목
  const [body, setBody] = useState(""); // 내용

  /// ✅ 확인모달 관련
  const [onlyConfirmModal, setOnlyConfirmModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [loading, setLoading] = useState(false);

  /// ✅ 글 등록
  const handleAddPost = async () => {
    setLoading(true);
    let type;

    switch (selectTabBar) {
      case "이야기":
        type = "농사 이야기";
        break;
      case "고장문의":
        type = "고장 문의";
        break;
      default:
        type = "";
        break;
    }

    /// file만 추출
    const imageFiles = images.map((imageData) => imageData.file[0]);

    const result = await createCommunityPost(
      title,
      body,
      type,
      userData,
      imageFiles
    );

    if (result) {
      setOnlyConfirmModal(true);
      setModalMessage("글 등록에 성공했습니다.");
      navigate("/community");
    } else {
      setOnlyConfirmModal(true);
      setModalMessage("글 등록에 실패했습니다.");
    }
    setLoading(false);
  };

  return (
    <>
      <div style={{ minHeight: isMobile ? "100%" : "calc(100vh - 72px)" }}>
        <div style={{ width: "100%", backgroundColor: "#ffffff" }}>
          <div
            style={{
              maxWidth: "1248px",
              padding: "16px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              margin: "auto",
              alignItems: "center",
            }}
          >
            {/* <img src={BackArrow} style={{ cursor: "pointer" }} onClick={() => navigate("/community")} /> */}
            <div className="f18_1F2937_W600">글쓰기</div>
            <div style={{ width: "18px" }}></div>
          </div>
        </div>
        <div className={Styles.divider} />
        <div
          className={Styles.container}
          style={{ maxWidth: "672px", margin: "auto" }}
        >
          <div className={Styles.spacer24} />
          {/* TabBar */}
          <div className={Styles.tabBar}>
            {tabBarItem.map((item) => (
              <WriteTabbarItemMobile
                currentTab={selectTabBar}
                item={item}
                onClick={() => {
                  setSelectTabBar(item);
                }}
              />
            ))}
          </div>
          <div className={Styles.spacer24} />

          <div
            className="f14_9CA3AF_W400"
            style={{ display: "flex", justifyContent: "end" }}
          >
            {"(" + title.length + "/100)"}
          </div>
          <input
            value={title}
            onChange={(e) => {
              if (e.target.value.length > 100) {
                setOnlyConfirmModal(true);
                setModalMessage("제목은 100글자 이내로 작성해주세요.");
                return;
              }
              setTitle(e.target.value);
            }}
            className={`${Styles.input} f16_1F2937_W400`}
            placeholder="제목을 입력하세요"
          />

          <div className={Styles.spacer24} />

          <div
            className="f14_9CA3AF_W400"
            style={{ display: "flex", justifyContent: "end" }}
          >
            {"(" + body.length + "/5000)"}
          </div>
          <textarea
            value={body}
            onChange={(e) => {
              if (e.target.value.length > 5000) {
                setOnlyConfirmModal(true);
                setModalMessage("내용은 5000글자 이내로 작성해주세요.");
                return;
              }
              setBody(e.target.value);
            }}
            className={`${Styles.textarea} f16_1F2937_W400`}
            style={{ height: "192px" }}
            placeholder="내용을 입력하세요"
          />

          <div className={Styles.spacer24} />

          <div style={{ display: "flex", flexDirection: "row", gap: "12px" }}>
            <div className="f14_4B5563_W400">사진 첨부</div>
            <div className="f14_9CA3AF_W400">
              {"("}
              {images.length}
              {"/5)"}
            </div>
          </div>

          <div style={{ height: "18px" }} />

          <WriteAddImageSlider images={images} setImages={setImages} />

          <div style={{ height: "56px" }} />
          {!isMobile && (
            <>
              <div
                onClick={() => {
                  if (!title.trim() || !body.trim()) {
                    setOnlyConfirmModal(true);
                    setModalMessage("제목 또는 내용이 비어있습니다.");
                    return;
                  }
                  setConfirmModal(true);
                }}
                className={`${Styles.postButton} f16_FFFFFF_W500`}
              >
                게시하기
              </div>
            </>
          )}
        </div>
      </div>
      {isMobile && (
        <>
          <div
            style={{
              position: "sticky",
              bottom: "0px",
              width: "100%",
              background: "#FFFFFF",
              padding: "16px",
              borderTop: "1px solid #E5E7EB",
              borderBottom: "1px solid #E5E7EB",
            }}
          >
            <div
              onClick={() => {
                if (!title.trim() || !body.trim()) {
                  setOnlyConfirmModal(true);
                  setModalMessage("제목 또는 내용이 비어있습니다.");
                  return;
                }
                setConfirmModal(true);
              }}
              className={`${Styles.postButton} f16_FFFFFF_W500`}
            >
              게시하기
            </div>
          </div>
        </>
      )}

      <ConfirmDialog
        open={confirmModal}
        onClose={() => setConfirmModal(false)}
        onConfirm={() => handleAddPost()}
        message={"해당내용을 등록하시겠습니까?"}
      />

      <OnlyConfirmDialog
        open={onlyConfirmModal}
        onClose={() => setOnlyConfirmModal(false)}
        message={modalMessage}
      />
      <OnlyLoadingScreen isOpen={loading} />
    </>
  );
}
